<!--
 * @Author: gongzhichao
 * @Date: 2023-05-09 16:25:00
 * @LastEditors: gongzhichao 18311120024@163.com
 * @Description: 详情页面-资料
-->
<template>
  <div class="main">
    <SecondPage>
             <!-- 标签切换区域 -->
             <div class="tab-buttons">
              <button 
                v-for="btn in  $config.dataInfoList" 
                :key="btn.selectType" 
                @click="toggleTab(btn.selectType)" 
                :class="currentTab === btn.selectType ? 'tab-button item-active' : 'tab-button item-def'"
              >
                  <div  :class="'tab-title'+ btn.tab">{{ btn.title }}</div>
                      <img
                        :src="btn.backgroundImg"
                        alt=""
                        :class="'people-tab' + btn.tab"
                      />
        </button>
        </div>
        <template v-if="currentTab === 'official'">
        <div
          class="information-content"
          v-for="item in gameDataList"
          :key="item.strategyType"
        >
          <div class="header">
            <div class="title">
              <span>{{ item.strategyType }}</span>
            </div>
          </div>
          <div class="list">
            <div
              class="list-item"
              v-for="e in item.strategyEntity.filter((e) => e.title != '无')"
              :key="e.id"
              @click="redirectPageToGameData(e)"
            >
              <img src="../../../assets/image/pc/second-page-listicon.png" alt />
              {{ e.title }}
            </div>
          </div>
        </div>
      </template>
      <div v-else-if="currentTab === 'highExplosive'">
        <div
          class="information-content"
          v-for="item in gameDataList"
          :key="item.strategyType"
        >
          <div class="header">
            <div class="title">
              <span>{{ item.strategyType }}</span>
            </div>
          </div>
          <div class="list">
            <div
              class="list-item"
              v-for="e in item.strategyEntity.filter((e) => e.title != '无')"
              :key="e.id"
              @click="redirectPageToGameData(e)"
            >
              <img src="../../../assets/image/pc/second-page-listicon.png" alt />
              {{ e.title }}
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="currentTab === 'threeExplosive'">
        <div
          class="information-content"
          v-for="item in gameDataList"
          :key="item.strategyType"
        >
          <div class="header">
            <div class="title">
              <span>{{ item.strategyType }}</span>
            </div>
          </div>
          <div class="list">
            <div
              class="list-item"
              v-for="e in item.strategyEntity.filter((e) => e.title != '无')"
              :key="e.id"
              @click="redirectPageToGameData(e)"
            >
              <img src="../../../assets/image/pc/second-page-listicon.png" alt />
              {{ e.title }}
            </div>
          </div>
        </div>
      </div>
    </SecondPage>
    <el-dialog :visible.sync="showVisible" append-to-body  >
      <div style="width: 100%; height: 60px; text-align: center;font-size: 24px;">暂未开放，敬请期待！</div>
   <div style=" margin-left:45%;">
     <el-button size="mini" @click="showVisible = false"
     >关闭</el-button
     >
   </div>
 </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import SecondPage from "../component/SecondPage/SecondPage.vue";
import webSiteHigh from "../../../api/webSiteHigh";
import webSite from "../../../api/webSite";
import webSiteThree from "../../../api/webSiteThree";
export default {
  metaInfo: {
    meta: [
      {
        name: "description",
        content:
          "《群侠传》是一款Q版千年武侠风格的即时战斗MMORPG游戏，自由探索、交易、战斗、结交各路英雄，能让你感觉到进入了一个充满江湖气息的世界！",
      },
      {
        name: "keywords",
        content:
          "群侠传,群侠传手游,群侠传官网,群侠传手游官网,千年,千年手游,千年官网,千年手游官网,群侠传,群侠传官网,群侠传手游,群侠传手游官网,九妖,九妖官网,九妖手游,九妖手游官网",
      },
    ],
  },
  data(){
 return{
  showVisible:false,
   gameDataList:[],
   currentTab: ''
 }
  },
  components: { SecondPage },
  mounted() {
    this.toggleTab();
  },
  methods: {
    ...mapActions({
      getArticle: "base/getArticle",
    }),
    

         // 切换标签
    // 切换标签
    toggleTab(tab) {
      if(tab != null && tab.trim() !== ''){
        sessionStorage.setItem('toggleTab', tab);
      }
      const storedValue = sessionStorage.getItem('toggleTab');

      if (tab === 'threeExplosive' || storedValue === 'threeExplosive' ) {
        this.currentTab="threeExplosive"
         this.getDataList(3)
      } else if (tab === 'highExplosive' || storedValue === 'highExplosive' ) {
        this.currentTab="highExplosive"
         this.getDataList(2)
      } else {
         this.currentTab="official"
         this.getDataList(1)
      }

    },
    async redirectPageToGameData(item) {
      try {
        let { id, title } = item;

        this.$router.push({
          path: "/detail",
          query: { id, title, path: "游戏资料" },
        });
      } catch (error) {
        console.info(error);
      }
    },

    async getDataList(type) {
      if(type==3){
      let gameType="游戏介绍,武学秘籍,江湖活动,副本介绍,装备大全,NPC/怪物"
      let res = await webSiteThree.searchGameData(gameType);
      this.gameDataList = res.data;

      }else if(type==2){
      let gameType="游戏介绍,武学秘籍,江湖活动,副本介绍,装备大全,NPC/怪物"
      let res = await webSiteHigh.searchGameData(gameType);
       this.gameDataList = res.data;

      }else{
      let gameType="游戏介绍,武学秘籍,江湖活动,副本介绍,装备大全,NPC/怪物"
      let res = await webSite.searchGameData(gameType);
       this.gameDataList = res.data;

      }

    },
  },

  // 组件路由守卫
  beforeRouteEnter(to, from, next) {
    let { title } = to.query;
    if (to.meta.title) document.title = title;
    next();
  },
};
</script>

<style lang="scss" scoped>
   .tab-buttons {
  display: flex;
  gap:8px; /* 按钮之间的间距 */
  justify-content: center; /* 按钮居中显示 */
  margin-top: 35px;
  margin-bottom: 20px;
  padding: 0 10px;
}

.tab-button {
  /* 基础按钮样式，确保文字居中 */
  border: none;
  cursor: pointer;
  font-size: 13px;
  font-weight:400;
  color: #704c13;
  padding: 8px 12px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  transition: all 0.3s ease;
  outline: none;
  flex: 1;
  max-width: 110px;

  /* 移除默认按钮样式 */
  &:focus {
    outline: none;
  }
}

// 默认状态样式
.item-def {
  background-image: url("../../../assets/image/pc/basemap-data-def.png");
  /* 根据实际图片尺寸调整按钮大小 */
  width: 100%;
  height: 50px;

}

// 激活状态样式
.item-active {
  background-image: url("../../../assets/image/pc/basemap-data-active.png");
  color: #f4f7f6; /* 激活状态文字颜色 */

  width:100%;
  height: 50px;
}
.tab-title1{
  width: 100%;
  font-size: 13px;
  text-align: center;
}
.tab-title2{
    width: 100%;
    height: 20px;
    font-size: 13px;
    margin-left: -16px;
}
.tab-title3{
  width: 100%;
  font-size: 13px;
  text-align: center;
}
.tab-button .people-tab1 {
  width: 60px;
 height: 60px;
  position: relative;
  margin-left: -117%;
  margin-top: -70%;
}

.tab-button .people-tab2 {
  width:60px;
  height: 70px;
  position: relative;
  margin-top: -95%;
  margin-left: 52%;
}
.tab-button .people-tab3 {
  width: 60px;
 height: 60px;
  position: relative;
  margin-left: -117%;
  margin-top: -70%;
}
.information-content {
  display: flex;
  flex-direction: column;
  border-bottom: 1px dashed #ccc;
  font-size: 10px;
  .header {
    display: flex;
    align-items: center;
    height: 50px;
    border-bottom: 1px dashed #ccc;
    .title {
      width: 60px;
      height: 25px;
      display: flex;
      align-items: center;
      background: url("../../../assets/image/pc/title-bg.png");
      background-size: 100% 100%;

      span {
        width: 60px;

        text-align: center;
        color: #fff;
        cursor: pointer;
      }
    }
  }
  .list {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    // margin-left: 50px;
    .list-item {
      display: flex;
      align-items: center;
      text-align: start;
      width: 33%;
      height: 40px;
      // margin-right: 30px;
      line-height: 40px;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }
}
.information-content:last-child {
  border-bottom: none;
}
</style>
